import Chart from 'react-apexcharts';

const SentimentData = (props) => {

    const {sentimentData, title, speaker} = props;

    let analysisData = [];

    if(speaker){
        analysisData = sentimentData?.filter(data => data.speaker === speaker);
    } else {
        analysisData = sentimentData;
    }

    const positive = analysisData?.filter(data => data.sentiment === 'POSITIVE').length;
    const negative = analysisData?.filter(data => data.sentiment === 'NEGATIVE').length;
    const neutral = analysisData?.filter(data => data.sentiment === 'NEUTRAL').length;

    const handleSliceClick = (event, chartContext, config) => {
        const dataIndex = config.dataPointIndex;
        const label = ['positive', 'negative', 'neutral'][dataIndex];
        console.log(`Clicked on slice "${label}"`);
    };

    return(
        <div>
            <Chart 
                options={{
                    chart: {
                        type: 'pie',
                        events: {
                            dataPointSelection: handleSliceClick
                        }
                    },
                    title: {
                        text: title,
                        style:{
                            fontFamily:'Sofia'
                        }
                    },
                    colors: ['#4395A2', '#E81F76', '#F6DFA4'],
                    labels: ['positive', 'negative', 'neutral'],
                    dataLabels:{
                        style:{
                            fontFamily:'Sofia'
                        }
                    },
                    legend:{
                        fontFamily:'Sofia',
                    },
                }}
                series={[positive, negative, neutral]}
                type='pie'
                height={150}
            />
        </div>
    )

}

export default SentimentData;